import { useEffect, useRef } from 'react'
import { useLogout } from './useAuth'

export const LogoutPage = () => {
	const { logout } = useLogout()
	const hasInitiatedLogout = useRef(false)

	useEffect(() => {
		// Prevent multiple logout calls even if component re-renders
		if (!hasInitiatedLogout.current) {
			hasInitiatedLogout.current = true
			// Trigger logout mutation - navigation and cleanup handled in useAuth
			logout.mutate()
		}
	}, [logout])

	return null
}
